module.exports = __webpack_public_path__ + "img/search.5255d113.svg";